export default __webpack_public_path__ + "static/media/6.7d82f40f.png";